import { FC } from "react";
import { TimeMarkerText } from "./TimeMarkerText";
import { DateTime } from "luxon";
import classNames from "classnames";

interface TimeMarkersProps {
  readonly hourMarks: DateTime[];
}

export const TimeMarkers: FC<TimeMarkersProps> = ({ hourMarks }) => {
  return (
    <>
      <div className="absolute ml-[px] flex h-[50px] w-[calc(100%-1px)] items-center justify-between">
        {hourMarks.map((dateTime) => (
          <div
            className={classNames(
              "z-0 w-[px] rounded-[2px]",
              "h-[15px] first-or-last:h-[22px]",
              "border border-emphasis first-or-last:border-2 first-or-last:border-input-hover",
            )}
            key={dateTime.toISO()}
          ></div>
        ))}
      </div>
      <div className="absolute ml-[px] flex h-[50px] w-[calc(100%-1px)] items-center justify-between">
        {hourMarks.map((dateTime, x) => (
          <TimeMarkerText
            first={x === 0}
            key={`${dateTime.toISO()}-x`}
            last={x === hourMarks.length - 1}
            dateTime={dateTime}
          />
        ))}
      </div>
    </>
  );
};
